module.exports = __webpack_public_path__ + "static/img/recommend_product_max.fd699f7a.png";